<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon
        class="ml-1"
        :class="['copy-icon', { copied }]"
        :size="size"
        @click="handleCopy"
        v-on="on"
      >
        {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CopyButton",
  props: {
    text: { type: String, required: true },
    size: { type: [Number, String], default: "small" }
  },
  data() {
    return { copied: false };
  },
  methods: {
    handleCopy() {
      if (!this.text) return;
      navigator.clipboard.writeText(this.text).then(() => {
        this.copied = true;
        this.$emit("copy", this.text);

        setTimeout(() => {
          this.copied = false;
        }, 2000); // Reset after 2 seconds
      });
    }
  }
};
</script>

<style scoped>
.copy-icon {
  transition: color 0.3s ease;
}
.copy-icon.copied {
  color: green;
}
</style>
